"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const Close_1 = require("@mui/icons-material/Close");
const merge_1 = require("merge");
const RotatedSquareIcon_1 = require("../../components/ModifiedIcons/RotatedSquareIcon");
const Loading_1 = require("../Loading");
const response_box_style_1 = require("./response-box.style");
const ResponseBox = ({ type, message, description, sx }) => {
    const styles = (0, response_box_style_1.default)({ type, hasDescription: !!description });
    const icon = (0, react_1.useMemo)(() => {
        switch (type) {
            default:
            case 'success':
                return (0, jsx_runtime_1.jsx)(RotatedSquareIcon_1.default, { success: true, IconComponent: icons_material_1.CheckRounded });
            case 'error':
                return (0, jsx_runtime_1.jsx)(RotatedSquareIcon_1.default, { error: true, IconComponent: Close_1.default });
            case 'pending':
                return (0, jsx_runtime_1.jsx)(Loading_1.default, { color: "text" });
        }
    }, [type]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: (0, merge_1.merge)(styles.mainContainer, sx), children: [(0, jsx_runtime_1.jsx)(material_1.Box, { component: "span", sx: styles.icon, children: icon }), (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: styles.textContainer, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { sx: styles.message, children: message }), (0, jsx_runtime_1.jsx)(material_1.Typography, { sx: styles.description, children: description })] })] }));
};
exports.default = ResponseBox;
